// import React, { useRef } from 'react';
// import { motion, useInView } from 'framer-motion';
// import { 
//   FaPlay, 
//   FaCheck, 
//   FaGraduationCap, 
//   FaUserTie, 
//   FaLaptopCode, 
//   FaAward, 
//   FaUsers, 
//   FaHandsHelping, 
//   FaFacebookF, 
//   FaTwitter, 
//   FaLinkedinIn,
//   FaArrowRight
// } from 'react-icons/fa';
// import  Cumpusbg from "../video/Cumpusbg.mp4";


// const campusBg = 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80';
// const AboutUs = () => {
//   const ref = useRef(null);
//   const isInView = useInView(ref, { once: true, amount: 0.1 });

//   // Animation variants
//   const container = {
//     hidden: { opacity: 0 },
//     show: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.2,
//         delayChildren: 0.3,
//       },
//     },
//   };

//   const item = {
//     hidden: { opacity: 0, y: 20 },
//     show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
//   };



//   const slideIn = (direction = 'left') => ({
//     hidden: { opacity: 0, x: direction === 'left' ? -50 : 50 },
//     show: { 
//       opacity: 1, 
//       x: 0, 
//       transition: { 
//         duration: 0.8,
//         ease: 'easeOut'
//       } 
//     },
//   });
  // // Team members data
  // const teamMembers = [
  //   {
  //     name: "Dr. Sarah Johnson",
  //     role: "Professor of Computer Science",
  //     image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=688&q=80",
  //     social: {
  //       facebook: "#",
  //       twitter: "#",
  //       linkedin: "#"
  //     }
  //   },
  //   {
  //     name: "Prof. Michael Chen",
  //     role: "Head of Engineering Department",
  //     image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80",
  //     social: {
  //       facebook: "#",
  //       twitter: "#",
  //       linkedin: "#"
  //     }
  //   },
  //   {
  //     name: "Dr. Emily Wilson",
  //     role: "Professor of Mathematics",
  //     image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80",
  //     social: {
  //       facebook: "#",
  //       twitter: "#",
  //       linkedin: "#"
  //     }
  //   },
  //   {
  //     name: "Prof. David Kim",
  //     role: "Director of Research",
  //     image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80",
  //     social: {
  //       facebook: "#",
  //       twitter: "#",
  //       linkedin: "#"
  //     }
  //   }
  // ];

  // // Core values data
  // const coreValues = [
  //   {
  //     number: "01",
  //     title: "Integrity",
  //     description: "We uphold the highest standards of integrity in all of our actions and decisions."
  //   },
  //   {
  //     number: "02",
  //     title: "Excellence",
  //     description: "We are committed to excellence in teaching, research, and community service."
  //   },
  //   {
  //     number: "03",
  //     title: "Innovation",
  //     description: "We foster creativity and innovative thinking in pursuit of knowledge."
  //   },
  //   {
  //     number: "04",
  //     title: "Diversity",
  //     description: "We value and respect the diversity of our community and promote inclusivity."
  //   }
  // ];

  // // Features data
  // const features = [
  //   {
  //     icon: <FaGraduationCap className="text-4xl text-primary mb-4" />,
  //     title: "Expert Faculty",
  //     description: "Learn from experienced and qualified faculty members who are experts in their fields."
  //   },
  //   {
  //     icon: <FaLaptopCode className="text-4xl text-primary mb-4" />,
  //     title: "Modern Facilities",
  //     description: "Access to state-of-the-art facilities and resources for an enhanced learning experience."
  //   },
  //   {
  //     icon: <FaUserTie className="text-4xl text-primary mb-4" />,
  //     title: "Career Support",
  //     description: "Comprehensive career services to help you transition from education to employment."
  //   },
  //   {
  //     icon: <FaAward className="text-4xl text-primary mb-4" />,
  //     title: "Accredited Programs",
  //     description: "Our programs are accredited and recognized by relevant educational authorities."
  //   },
  //   {
  //     icon: <FaUsers className="text-4xl text-primary mb-4" />,
  //     title: "Diverse Community",
  //     description: "Join a diverse and inclusive community of students from various backgrounds."
  //   },
  //   {
  //     icon: <FaHandsHelping className="text-4xl text-primary mb-4" />,
  //     title: "Student Support",
  //     description: "Dedicated support services to ensure your academic success and well-being."
  //   }
  // ];

//   return (
//     <div className="min-h-screen flex flex-col bg-gray-50">
//       {/* Hero Banner - Background Image Only */}
//       <motion.div 
//         className="relative h-80 md:h-96 overflow-hidden bg-cover bg-center"
//         style={{
//           backgroundImage: "url('https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')",
//           backgroundPosition: 'center center',
//           backgroundSize: 'cover',
//           backgroundRepeat: 'no-repeat'
//         }}
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ duration: 0.8 }}
//       />

//       {/* Welcome Section */}
//       <motion.section 
//         className="py-16 md:py-24 bg-white shadow-sm overflow-hidden"
//         ref={ref}
//         initial="hidden"
//         animate={isInView ? "show" : "hidden"}
//         variants={container}
//       >
//         <div className="container mx-auto px-4">
//           <motion.div className="flex flex-col lg:flex-row items-center" variants={container}>
//             {/* Left Column - Video Thumbnail */}
//             <motion.div 
//               className="lg:w-1/2 mb-12 lg:mb-0 lg:pr-12"
//               variants={slideIn('right')}
//             >
//               <motion.div 
//                 className="relative rounded-lg overflow-hidden shadow-2xl"
//                 whileHover={{ scale: 1.02 }}
//                 transition={{ type: 'spring', stiffness: 300 }}
//               >
                <div 
                  className="w-full h-64 md:h-96 bg-cover bg-center"
                  style={{
                    backgroundImage: 'url(https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: 0
                  }}
                />
//               </motion.div>
//             </motion.div>
            
//             {/* Right Column - Content */}
//             <motion.div 
//               className="lg:w-1/2"
//               variants={slideIn('left')}
//             >
//               <motion.div 
//                 className="inline-block px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-4"
//                 variants={item}
//               >
//                 About Us
//               </motion.div>
//               <motion.h2 
//                 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6"
//                 variants={item}
//               >
//                 Welcome to Our College
//               </motion.h2>
//               <motion.div 
//                 className="w-20 h-1 bg-primary mb-6"
//                 variants={item}
//               />
//               <motion.p 
//                 className="text-black mb-6"
//                 variants={item}
//               >
//                 At FIC College, we are committed to providing a transformative educational experience that prepares students for success in an ever-changing world. Our student-centered approach to learning fosters innovation, critical thinking, and leadership skills that will serve our graduates throughout their lives. With a dedicated faculty of accomplished scholars and industry professionals, we offer a dynamic learning environment that combines academic excellence with real-world application. Our state-of-the-art facilities and comprehensive support services create an inclusive community where every student can thrive and achieve their full potential.
//               </motion.p>
//               <motion.p 
//                 className="text-black mb-8"
//                 variants={item}
//               >
//                 Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
//               </motion.p>
              
//               <motion.div 
//                 className="grid md:grid-cols-2 gap-6 mb-8"
//                 variants={container}
//               >
//                 <motion.div 
//                   className="bg-gray-50 p-6 rounded-lg border-l-4 border-primary hover:shadow-md transition-all"
//                   variants={item}
//                   whileHover={{ y: -5 }}
//                 >
//                   <h3 className="text-xl font-semibold text-gray-900 mb-2">Our Mission</h3>
//                   <p className="text-black">
//                     To provide quality education that transforms students into responsible global citizens.
//                   </p>
//                 </motion.div>
//                 <motion.div 
//                   className="bg-gray-50 p-6 rounded-lg border-l-4 border-secondary hover:shadow-md transition-all"
//                   variants={item}
//                   whileHover={{ y: -5 }}
//                 >
//                   <h3 className="text-xl font-semibold text-gray-900 mb-2">Our Vision</h3>
//                   <p className="text-black">
//                     To be a world-class institution that fosters innovation and academic excellence.
//                   </p>
//                 </motion.div>
//               </motion.div>
              
//               <motion.ul 
//                 className="space-y-3 mb-8"
//                 variants={container}
//               >
//                 {[
//                   'Quality Education',
//                   'Professional Teachers',
//                   'Industry-Ready Programs',
//                   'Modern Facilities',
//                   'Career Support'
//                 ].map((itemText, index) => (
//                   <motion.li 
//                     key={index} 
//                     className="flex items-center text-black"
//                     variants={item}
//                     whileHover={{ x: 5 }}
//                   >
//                     <FaCheck className="text-green-500 mr-2" />
//                     {itemText}
//                   </motion.li>
//                 ))}
//               </motion.ul>
//             </motion.div>
//           </motion.div>
//         </div>
//       </motion.section>

//       {/* Stats Section */}
//       <motion.section 
//         className="py-16 bg-gradient-to-br from-white to-gray-50 overflow-hidden"
//         initial={{ opacity: 0, y: 50 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true, margin: "-100px" }}
//         transition={{ duration: 0.8 }}
//       >
//         <div className="container mx-auto px-4">
//           <motion.div 
//             className="grid grid-cols-2 md:grid-cols-4 gap-8"
//             variants={container}
//             initial="hidden"
//             whileInView="show"
//             viewport={{ once: true, margin: "-100px" }}
//           >
//             {[
//               { number: '5000+', label: 'Students', icon: <FaGraduationCap className="text-4xl text-primary mx-auto mb-4" /> },
//               { number: '250+', label: 'Faculty Members', icon: <FaUserTie className="text-4xl text-primary mx-auto mb-4" /> },
//               { number: '50+', label: 'Programs', icon: <FaLaptopCode className="text-4xl text-primary mx-auto mb-4" /> },
//               { number: '95%', label: 'Graduation Rate', icon: <FaAward className="text-4xl text-primary mx-auto mb-4" /> }
//             ].map((stat, index) => (
//               <motion.div 
//                 key={index} 
//                 className="text-center p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-all"
//                 variants={item}
//                 whileHover={{ y: -10, boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' }}
//               >
//                 <motion.div 
//                   initial={{ scale: 0.8, opacity: 0 }}
//                   whileInView={{ scale: 1, opacity: 1 }}
//                   viewport={{ once: true }}
//                   transition={{ delay: index * 0.1, duration: 0.5 }}
//                 >
//                   {stat.icon}
//                 </motion.div>
//                 <motion.h3 
//                   className="text-3xl font-bold text-gray-900 mb-2"
//                   initial={{ y: 20, opacity: 0 }}
//                   whileInView={{ y: 0, opacity: 1 }}
//                   viewport={{ once: true }}
//                   transition={{ delay: index * 0.1 + 0.2, duration: 0.5 }}
//                 >
//                   {stat.number}
//                 </motion.h3>
//                 <motion.p 
//                   className="text-gray-600"
//                   initial={{ y: 10, opacity: 0 }}
//                   whileInView={{ y: 0, opacity: 1 }}
//                   viewport={{ once: true }}
//                   transition={{ delay: index * 0.1 + 0.3, duration: 0.5 }}
//                 >
//                   {stat.label}
//                 </motion.p>
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>
//       </motion.section>

//       {/* Core Values Section */}
//       <motion.section 
//         className="py-16 bg-white relative overflow-hidden"
//         initial={{ opacity: 0, y: 50 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true, margin: "-100px" }}
//         transition={{ duration: 0.8 }}
//       >
//         <motion.div 
//           className="absolute inset-0 bg-grid-gray-100 [mask-image:linear-gradient(0deg,#fff,rgba(255,255,255,0.6))]"
//           initial={{ opacity: 0 }}
//           whileInView={{ opacity: 1 }}
//           viewport={{ once: true }}
//           transition={{ duration: 1 }}
//         />
//         <div className="relative z-10">
//           <div className="container mx-auto px-4">
//             <motion.div 
//               className="text-center max-w-3xl mx-auto mb-16"
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.6 }}
//             >
//               <motion.div 
//                 className="inline-block px-4 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-4"
//                 initial={{ opacity: 0, scale: 0.9 }}
//                 whileInView={{ opacity: 1, scale: 1 }}
//                 viewport={{ once: true }}
//                 transition={{ duration: 0.5 }}
//               >
//                 Our Values
//               </motion.div>
//               <motion.h2 
//                 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: 0.1, duration: 0.6 }}
//               >
//                 Core Values That Define Us
//               </motion.h2>
//               <motion.div 
//                 className="w-20 h-1 bg-primary mx-auto mb-6"
//                 initial={{ scaleX: 0 }}
//                 whileInView={{ scaleX: 1 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: 0.2, duration: 0.8, ease: "backOut" }}
//               />
//               <motion.p 
//                 className="text-black"
//                 initial={{ opacity: 0, y: 10 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: 0.3, duration: 0.6 }}
//               >
//                 We are committed to upholding these core values in everything we do, ensuring the highest standards of education and student experience.
//               </motion.p>
//             </motion.div>
            
//             <motion.div 
//               className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"
//               variants={container}
//               initial="hidden"
//               whileInView="show"
//               viewport={{ once: true, margin: "-50px" }}
//             >
//               {coreValues.map((value, index) => (
//                 <motion.div 
//                   key={index} 
//                   className="bg-gray-50 p-8 rounded-lg hover:shadow-lg transition-all duration-300 group"
//                   variants={item}
//                   whileHover={{ 
//                     y: -10,
//                     boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
//                     scale: 1.02
//                   }}
//                   initial={{ opacity: 0, y: 30 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ 
//                     delay: index * 0.1, 
//                     duration: 0.6,
//                     type: 'spring',
//                     stiffness: 80
//                   }}
//                 >
//                   <motion.div 
//                     className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center text-primary text-2xl mb-4 group-hover:bg-primary/20 transition-colors"
//                     initial={{ rotate: -15, scale: 0.8 }}
//                     whileInView={{ rotate: 0, scale: 1 }}
//                     viewport={{ once: true }}
//                     transition={{ 
//                       delay: index * 0.1 + 0.1,
//                       type: 'spring',
//                       stiffness: 100
//                     }}
//                   >
//                     <span className="font-bold">{value.number}</span>
//                   </motion.div>
//                   <motion.h3 
//                     className="text-xl font-semibold text-gray-900 mb-3"
//                     initial={{ opacity: 0, y: 10 }}
//                     whileInView={{ opacity: 1, y: 0 }}
//                     viewport={{ once: true }}
//                     transition={{ delay: index * 0.1 + 0.2, duration: 0.5 }}
//                   >
//                     {value.title}
//                   </motion.h3>
//                   <motion.p 
//                     className="text-black"
//                     initial={{ opacity: 0, y: 10 }}
//                     whileInView={{ opacity: 1, y: 0 }}
//                     viewport={{ once: true }}
//                     transition={{ delay: index * 0.1 + 0.3, duration: 0.5 }}
//                   >
//                     {value.description}
//                   </motion.p>
//                 </motion.div>
//               ))}
//             </motion.div>
//           </div>
//         </div>
//       </motion.section>

//       {/* Why Choose Us Section */}
//       <motion.section 
//         className="py-16 bg-gradient-to-br from-gray-50 to-white overflow-hidden"
//         initial={{ opacity: 0, y: 50 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true, margin: "-100px" }}
//         transition={{ duration: 0.8 }}
//       >
//         <div className="container mx-auto px-4">
//           <motion.div 
//             className="text-center max-w-3xl mx-auto mb-16"
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6 }}
//           >
//             <motion.div 
//               className="inline-block px-4 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-4"
//               initial={{ opacity: 0, scale: 0.9 }}
//               whileInView={{ opacity: 1, scale: 1 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.5 }}
//             >
//               Why Choose Us
//             </motion.div>
//             <motion.h2 
//               className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ delay: 0.1, duration: 0.6 }}
//             >
//               Why Students Choose Our Institution
//             </motion.h2>
//             <motion.div 
//               className="w-20 h-1 bg-primary mx-auto mb-6"
//               initial={{ scaleX: 0 }}
//               whileInView={{ scaleX: 1 }}
//               viewport={{ once: true }}
//               transition={{ delay: 0.2, duration: 0.8, ease: "backOut" }}
//             />
//             <motion.p 
//               className="text-black"
//               initial={{ opacity: 0, y: 10 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ delay: 0.3, duration: 0.6 }}
//             >
//               We provide an exceptional learning environment with comprehensive support services to help you achieve your academic and career goals.
//             </motion.p>
//           </motion.div>
          
//           <motion.div 
//             className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
//             variants={container}
//             initial="hidden"
//             whileInView="show"
//             viewport={{ once: true, margin: "-50px" }}
//           >
//             {features.map((feature, index) => (
//               <motion.div 
//                 key={index} 
//                 className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 text-center group"
//                 variants={item}
//                 whileHover={{ 
//                   y: -10,
//                   boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
//                   scale: 1.02
//                 }}
//                 initial={{ opacity: 0, y: 30 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ 
//                   delay: index * 0.1, 
//                   duration: 0.6,
//                   type: 'spring',
//                   stiffness: 80
//                 }}
//               >
//                 <motion.div 
//                   className="mb-4"
//                   initial={{ scale: 0.8, opacity: 0 }}
//                   whileInView={{ scale: 1, opacity: 1 }}
//                   viewport={{ once: true }}
//                   transition={{ 
//                     delay: index * 0.1 + 0.1,
//                     type: 'spring',
//                     stiffness: 100
//                   }}
//                 >
//                   {feature.icon}
//                 </motion.div>
//                 <motion.h3 
//                   className="text-xl font-semibold text-gray-900 mb-3"
//                   initial={{ opacity: 0, y: 10 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ delay: index * 0.1 + 0.2, duration: 0.5 }}
//                 >
//                   {feature.title}
//                 </motion.h3>
//                 <motion.p 
//                   className="text-black"
//                   initial={{ opacity: 0, y: 10 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ delay: index * 0.1 + 0.3, duration: 0.5 }}
//                 >
//                     {feature.description}
//                   </motion.p>
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>
//       </motion.section>

//       {/* Testimonials Section */}
//       <motion.section 
//         className="py-16 bg-gray-50 overflow-hidden"
//         initial={{ opacity: 0, y: 50 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true, margin: "-100px" }}
//         transition={{ duration: 0.8 }}
//       >
//         <div className="container mx-auto px-4">
//           <motion.div 
//             className="text-center max-w-3xl mx-auto mb-12"
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.6 }}
//           >
//             <motion.div 
//               className="inline-block px-4 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-4"
//               initial={{ opacity: 0, scale: 0.9 }}
//               whileInView={{ opacity: 1, scale: 1 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.5 }}
//             >
//               Testimonials
//             </motion.div>
//             <motion.h2 
//               className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ delay: 0.1, duration: 0.6 }}
//             >
//               What Our Community Says
//             </motion.h2>
//             <motion.div 
//               className="w-20 h-1 bg-primary mx-auto mb-6"
//               initial={{ scaleX: 0 }}
//               whileInView={{ scaleX: 1 }}
//               viewport={{ once: true }}
//               transition={{ delay: 0.2, duration: 0.8, ease: "backOut" }}
//             />
//           </motion.div>
          
//           <motion.div 
//             className="grid md:grid-cols-3 gap-8"
//             variants={container}
//             initial="hidden"
//             whileInView="show"
//             viewport={{ once: true, margin: "-50px" }}
//           >
//             {[
//               {
//                 quote: "The faculty's dedication to student success is truly remarkable. The hands-on learning approach prepared me exceptionally well for my career.",
//                 author: "Alex Johnson",
//                 role: "Computer Science Graduate, Class of 2023"
//               },
//               {
//                 quote: "The diverse community and inclusive environment made my learning experience enriching. I've built connections that will last a lifetime.",
//                 author: "Maria Garcia",
//                 role: "Business Administration, Class of 2024"
//               },
//               {
//                 quote: "The research opportunities and mentorship I received were instrumental in my academic growth. Truly a transformative experience.",
//                 author: "James Wilson",
//                 role: "Research Assistant, Engineering Department"
//               }
//             ].map((testimonial, index) => (
//               <motion.div 
//                 key={index} 
//                 className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 group"
//                 variants={item}
//                 whileHover={{ 
//                   y: -10,
//                   boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
//                   scale: 1.02
//                 }}
//                 initial={{ opacity: 0, y: 30 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ 
//                   delay: index * 0.15, 
//                   duration: 0.6,
//                   type: 'spring',
//                   stiffness: 80
//                 }}
//               >
//                 <motion.div 
//                   className="text-yellow-400 text-2xl mb-4"
//                   initial={{ opacity: 0, scale: 0.8 }}
//                   whileInView={{ opacity: 1, scale: 1 }}
//                   viewport={{ once: true }}
//                   transition={{ 
//                     delay: index * 0.15 + 0.1,
//                     type: 'spring',
//                     stiffness: 100
//                   }}
//                 >
//                   "
//                 </motion.div>
//                 <motion.p 
//                   className="text-black italic mb-4"
//                   initial={{ opacity: 0, y: 10 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ delay: index * 0.15 + 0.2, duration: 0.5 }}
//                 >
//                   {testimonial.quote}
//                 </motion.p>
//                 <motion.div 
//                   className="border-t border-gray-100 pt-4"
//                   initial={{ opacity: 0, y: 10 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ delay: index * 0.15 + 0.3, duration: 0.5 }}
//                 >
//                   <p className="font-semibold text-black">{testimonial.author}</p>
//                   <p className="text-sm text-black">{testimonial.role}</p>
//                 </motion.div>
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>
//       </motion.section>

//       {/* Team Section */}
//       <motion.section 
//         className="py-16 bg-white relative overflow-hidden"
//         initial={{ opacity: 0, y: 50 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true, margin: "-100px" }}
//         transition={{ duration: 0.8 }}
//       >
//         <motion.div 
//           className="absolute inset-0 bg-grid-primary-100/20 [mask-image:linear-gradient(0deg,#fff,rgba(255,255,255,0.6))]"
//           initial={{ opacity: 0 }}
//           whileInView={{ opacity: 1 }}
//           viewport={{ once: true }}
//           transition={{ duration: 1 }}
//         />
//         <div className="relative z-10">
//           <div className="container mx-auto px-4">
//             <motion.div 
//               className="text-center max-w-3xl mx-auto mb-16"
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.6 }}
//             >
//               <motion.div 
//                 className="inline-block px-4 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-4"
//                 initial={{ opacity: 0, scale: 0.9 }}
//                 whileInView={{ opacity: 1, scale: 1 }}
//                 viewport={{ once: true }}
//                 transition={{ duration: 0.5 }}
//               >
//                 Our Team
//               </motion.div>
//               <motion.h2 
//                 className="text-3xl md:text-4xl font-bold text-black mb-4"
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: 0.1, duration: 0.6 }}
//               >
//                 Meet Our Expert Team Members
//               </motion.h2>
//               <motion.div 
//                 className="w-20 h-1 bg-primary mx-auto mb-6"
//                 initial={{ scaleX: 0 }}
//                 whileInView={{ scaleX: 1 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: 0.2, duration: 0.8, ease: "backOut" }}
//               />
//               <motion.p 
//                 className="text-black"
//                 initial={{ opacity: 0, y: 10 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: 0.3, duration: 0.6 }}
//               >
//                 Our dedicated team of experienced educators and researchers are committed to providing quality education and mentorship.
//               </motion.p>
//             </motion.div>
            
//             <motion.div 
//               className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"
//               variants={container}
//               initial="hidden"
//               whileInView="show"
//               viewport={{ once: true, margin: "-50px" }}
//             >
//               {teamMembers.map((member, index) => (
//                 <motion.div 
//                   key={index} 
//                   className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 group"
//                   variants={item}
//                   whileHover={{ 
//                     y: -10,
//                     boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
//                     scale: 1.02
//                   }}
//                   initial={{ opacity: 0, y: 30 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ 
//                     delay: index * 0.1, 
//                     duration: 0.6,
//                     type: 'spring',
//                     stiffness: 80
//                   }}
//                 >
//                   <motion.div 
//                     className="overflow-hidden h-64 relative"
//                     whileHover={{ scale: 1.05 }}
//                     transition={{ duration: 0.5 }}
//                   >
//                     <img 
//                       src={member.image}
//                       alt={`Portrait of ${member.name}, ${member.role}`}
//                       className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
//                       loading="lazy"
//                       width="300"
//                       height="300"
//                       sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
//                     />
//                     <motion.div 
//                       className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6"
//                       initial={{ opacity: 0 }}
//                       whileHover={{ opacity: 1 }}
//                     >
//                       <div className="flex justify-center space-x-4 w-full">
//                         <motion.a 
//                           href={member.social.facebook} 
//                           className="text-white hover:text-primary transition-colors bg-black/30 backdrop-blur-sm p-2 rounded-full"
//                           whileHover={{ y: -5, scale: 1.1 }}
//                           whileTap={{ scale: 0.9 }}
//                         >
//                           <FaFacebookF className="text-lg" />
//                         </motion.a>
//                         <motion.a 
//                           href={member.social.twitter} 
//                           className="text-white hover:text-primary transition-colors bg-black/30 backdrop-blur-sm p-2 rounded-full"
//                           whileHover={{ y: -5, scale: 1.1 }}
//                           whileTap={{ scale: 0.9 }}
//                         >
//                           <FaTwitter className="text-lg" />
//                         </motion.a>
//                         <motion.a 
//                           href={member.social.linkedin} 
//                           className="text-white hover:text-primary transition-colors bg-black/30 backdrop-blur-sm p-2 rounded-full"
//                           whileHover={{ y: -5, scale: 1.1 }}
//                           whileTap={{ scale: 0.9 }}
//                         >
//                           <FaLinkedinIn className="text-lg" />
//                         </motion.a>
//                       </div>
//                     </motion.div>
//                   </motion.div>
//                   <div className="p-6 text-center">
//                     <motion.h3 
//                       className="text-xl font-semibold text-gray-900 mb-1"
//                       initial={{ opacity: 0, y: 10 }}
//                       whileInView={{ opacity: 1, y: 0 }}
//                       viewport={{ once: true }}
//                       transition={{ delay: index * 0.1 + 0.2, duration: 0.5 }}
//                     >
//                       {member.name}
//                     </motion.h3>
//                     <motion.p 
//                       className="text-primary font-medium mb-4"
//                       initial={{ opacity: 0, y: 10 }}
//                       whileInView={{ opacity: 1, y: 0 }}
//                       viewport={{ once: true }}
//                       transition={{ delay: index * 0.1 + 0.3, duration: 0.5 }}
//                     >
//                       {member.role}
//                     </motion.p>
//                   </div>
//                 </motion.div>
//               ))}
//             </motion.div>
            
//             <motion.div 
//               className="text-center mt-12"
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ delay: 0.3, duration: 0.6 }}
//             >
//               <motion.button 
//                 className="bg-primary hover:bg-primary/90 text-white font-medium py-3 px-8 rounded-md transition-colors inline-flex items-center group"
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//               >
//                 View All Faculty Members
//                 <motion.span 
//                   className="ml-2 inline-flex items-center"
//                   animate={{ x: [0, 5, 0] }}
//                   transition={{ repeat: Infinity, duration: 1.5, ease: 'easeInOut' }}
//                 >
//                   <FaArrowRight />
//                 </motion.span>
//               </motion.button>
//             </motion.div>
//           </div>
//         </div>
//       </motion.section>

//       {/* Footer */}
      
//     </div>
//   );
// };

import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { 
  FaCheck, 
  FaGraduationCap, 
  FaUserTie, 
  FaLaptopCode, 
  FaAward, 
  FaUsers, 
  FaHandsHelping, 
  FaFacebookF, 
  FaTwitter, 
  FaLinkedinIn
} from 'react-icons/fa';
import img1 from '../Images/img1.jpg';
import img2 from '../Images/img2.jpg';
import img3 from '../Images/img3.jpg';
import img4 from '../Images/img4.jpg';
import img5 from '../Images/img5.jpg';

const campusBg = 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80';

const AboutUs = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.1 });



  // Animation variants
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const slideIn = (direction = 'left') => ({
    hidden: { opacity: 0, x: direction === 'left' ? -50 : 50 },
    show: { 
      opacity: 1, 
      x: 0, 
      transition: { 
        duration: 0.8,
        ease: 'easeOut'
      } 
    },
  });

  

  // Data (teamMembers, coreValues, features) remains the same
    // Team members data
  const teamMembers = [
    {
      name: "Muhammad Jamshaid Ahmad",
      role: "First International Consultants",
      image: img1,
      social: {
        facebook: "#",
        twitter: "#",
        linkedin: "#"
      }
    },
    {
      name: "Prof. Qazi Arbab Akbar Farooqi",
      role: "CEO, First International College",
      image: img2,
      social: {
        facebook: "#",
        twitter: "#",
        linkedin: "#"
      }
    },
    {
      name: "Sahibzada Ali Ahmad",
      role: "CEO, AJN International College",
      image: img3,
      social: {
        facebook: "#",
        twitter: "#",
        linkedin: "#"
      }
    },
    {
      name: "Hashir Mehmood",
      role: "Executive Director, First International College",
      image: img4,
      social: {
        facebook: "#",
        twitter: "#",
        linkedin: "#"
      }
    },
    {
      name: "Huma Sadiq",
      role: "Director & Head of Operations, First International Consultants",
      image: img5,
      social: {
        facebook: "#",
        twitter: "#",
        linkedin: "#"
      }
    },
  ];
    // Core values data
  const coreValues = [
    {
      number: "01",
      title: "Integrity",
      description: "We uphold the highest standards of integrity in all of our actions and decisions."
    },
    {
      number: "02",
      title: "Excellence",
      description: "We are committed to excellence in teaching, research, and community service."
    },
    {
      number: "03",
      title: "Innovation",
      description: "We foster creativity and innovative thinking in pursuit of knowledge."
    },
    {
      number: "04",
      title: "Diversity",
      description: "We value and respect the diversity of our community and promote inclusivity."
    }
  ];

  
  // Features data
  const features = [
    {
      icon: <FaGraduationCap className="text-4xl text-primary mb-4" />,
      title: "Expert Faculty",
      description: "Learn from experienced and qualified faculty members who are experts in their fields."
    },
    {
      icon: <FaLaptopCode className="text-4xl text-primary mb-4" />,
      title: "Modern Facilities",
      description: "Access to state-of-the-art facilities and resources for an enhanced learning experience."
    },
    {
      icon: <FaUserTie className="text-4xl text-primary mb-4" />,
      title: "Career Support",
      description: "Comprehensive career services to help you transition from education to employment."
    },
    {
      icon: <FaAward className="text-4xl text-primary mb-4" />,
      title: "Accredited Programs",
      description: "Our programs are accredited and recognized by relevant educational authorities."
    },
    {
      icon: <FaUsers className="text-4xl text-primary mb-4" />,
      title: "Diverse Community",
      description: "Join a diverse and inclusive community of students from various backgrounds."
    },
    {
      icon: <FaHandsHelping className="text-4xl text-primary mb-4" />,
      title: "Student Support",
      description: "Dedicated support services to ensure your academic success and well-being."
    }
  ];




  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Hero Banner - Background Image Only */}
      <motion.div 
        className="relative h-80 md:h-96 overflow-hidden bg-cover bg-center flex items-center justify-center"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')",
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        {/* Dark overlay for better text readability */}
        <div className="absolute inset-0 bg-black/40 z-0"></div>
        
        {/* Hero content */}
        <div className="relative z-10 text-center px-4">
          <motion.h1 
            className="text-3xl md:text-5xl font-bold text-white mb-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Welcome to FIC College
          </motion.h1>
          <motion.p 
            className="text-lg md:text-xl text-white max-w-2xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Shaping futures with academic excellence, innovation, and global perspective.
          </motion.p>
        </div>
      </motion.div>

      {/* Welcome Section */}
      <motion.section 
        className="py-16 md:py-24 bg-white shadow-sm overflow-hidden"
        ref={ref}
        initial="hidden"
        animate={isInView ? "show" : "hidden"}
        variants={container}
      >
        <div className="container mx-auto px-4">
          <motion.div className="flex flex-col lg:flex-row items-center" variants={container}>
            
            {/* ====================================================== */}
            {/* === START: IMAGE SECTION ============================ */}
            {/* ====================================================== */}
            <motion.div 
              className="lg:w-1/2 mb-12 lg:mb-0 lg:pr-12"
              variants={slideIn('right')}
            >
              <motion.div 
                className="relative rounded-lg overflow-hidden shadow-2xl aspect-video"
                whileHover={{ scale: 1.02 }}
                transition={{ type: 'spring', stiffness: 300 }}
                style={{
                  backgroundImage: 'url(https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80)',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat'
                }}
              />
            </motion.div>
            {/* ====================================================== */}
            {/* === END: IMAGE SECTION ============================== */}
            {/* ====================================================== */}
            
            {/* Right Column - Content */}
            <motion.div 
              className="lg:w-1/2"
              variants={slideIn('left')}
            >
              <motion.div 
                className="inline-block px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-4"
                variants={item}
              >
                About Us
              </motion.div>
              <motion.h2 
                className="text-3xl md:text-4xl font-bold text-gray-900 mb-6"
                variants={item}
              >
                Welcome to Our College
              </motion.h2>
              <motion.div 
                className="w-20 h-1 bg-primary mb-6"
                variants={item}
              />
              <motion.p 
                className="text-black mb-6"
                variants={item}
              >
                At FIC College, we are committed to excellence in education, fostering innovation, and nurturing the leaders of tomorrow. Our student-centered approach ensures that each individual receives personalized attention and support to achieve their full potential. With a focus on academic rigor, practical skills, and character development, we prepare our students to make meaningful contributions to society and excel in their chosen fields.
              </motion.p>

              <motion.div 
                className="grid md:grid-cols-2 gap-6 mb-8"
                variants={container}
              >
                <motion.div 
                  className="bg-gray-50 p-6 rounded-lg border-l-4 border-primary hover:shadow-md transition-all"
                  variants={item}
                  whileHover={{ y: -5 }}
                >
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Our Mission</h3>
                  <p className="text-black">
                    To provide quality education that transforms students into responsible global citizens.
                  </p>
                </motion.div>
                <motion.div 
                  className="bg-gray-50 p-6 rounded-lg border-l-4 border-secondary hover:shadow-md transition-all"
                  variants={item}
                  whileHover={{ y: -5 }}
                >
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Our Vision</h3>
                  <p className="text-black">
                    To be a world-class institution that fosters innovation and academic excellence.
                  </p>
                </motion.div>
              </motion.div>
              
              <motion.ul 
                className="space-y-3 mb-8"
                variants={container}
              >
                {[
                  'Quality Education',
                  'Professional Teachers',
                  'Industry-Ready Programs',
                  'Modern Facilities',
                  'Career Support'
                ].map((itemText, index) => (
                  <motion.li 
                    key={index} 
                    className="flex items-center text-black"
                    variants={item}
                    whileHover={{ x: 5 }}
                  >
                    <FaCheck className="text-green-500 mr-2" />
                    {itemText}
                  </motion.li>
                ))}
              </motion.ul>
            </motion.div>
          </motion.div>
        </div>
      </motion.section>

      {/* --- Rest of your sections (Stats, Core Values, etc.) --- */}
      {/* --- No changes needed in the sections below --- */}

      {/* Core Values Section */}
      <motion.section 
        className="py-16 bg-white relative overflow-hidden"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8 }}
      >
        <motion.div 
          className="absolute inset-0 bg-grid-gray-100 [mask-image:linear-gradient(0deg,#fff,rgba(255,255,255,0.6))]"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        />
        <div className="relative z-10">
          <div className="container mx-auto px-4">
            <motion.div 
              className="text-center max-w-3xl mx-auto mb-16"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <motion.div 
                className="inline-block px-4 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-4"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
              >
                Our Values
              </motion.div>
              <motion.h2 
                className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1, duration: 0.6 }}
              >
                Core Values That Define Us
              </motion.h2>
              <motion.div 
                className="w-20 h-1 bg-primary mx-auto mb-6"
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2, duration: 0.8, ease: "backOut" }}
              />
              <motion.p 
                className="text-black"
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3, duration: 0.6 }}
              >
                We are committed to upholding these core values in everything we do, ensuring the highest standards of education and student experience.
              </motion.p>
            </motion.div>
            
            <motion.div 
              className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"
              variants={container}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-50px" }}
            >
              {coreValues.map((value, index) => (
                <motion.div 
                  key={index} 
                  className="bg-gray-50 p-8 rounded-lg hover:shadow-lg transition-all duration-300 group"
                  variants={item}
                  whileHover={{ 
                    y: -10,
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                    scale: 1.02
                  }}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ 
                    delay: index * 0.1, 
                    duration: 0.6,
                    type: 'spring',
                    stiffness: 80
                  }}
                >
                  <motion.div 
                    className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center text-primary text-2xl mb-4 group-hover:bg-primary/20 transition-colors"
                    initial={{ rotate: -15, scale: 0.8 }}
                    whileInView={{ rotate: 0, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ 
                      delay: index * 0.1 + 0.1,
                      type: 'spring',
                      stiffness: 100
                    }}
                  >
                    <span className="font-bold">{value.number}</span>
                  </motion.div>
                  <motion.h3 
                    className="text-xl font-semibold text-gray-900 mb-3"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.1 + 0.2, duration: 0.5 }}
                  >
                    {value.title}
                  </motion.h3>
                  <motion.p 
                    className="text-black"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.1 + 0.3, duration: 0.5 }}
                  >
                    {value.description}
                  </motion.p>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* Why Choose Us Section */}
      <motion.section 
        className="py-16 bg-gradient-to-br from-gray-50 to-white overflow-hidden"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container mx-auto px-4">
          <motion.div 
            className="text-center max-w-3xl mx-auto mb-16"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <motion.div 
              className="inline-block px-4 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-4"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              Why Choose Us
            </motion.div>
            <motion.h2 
              className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1, duration: 0.6 }}
            >
              Why Students Choose Our Institution
            </motion.h2>
            <motion.div 
              className="w-20 h-1 bg-primary mx-auto mb-6"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.8, ease: "backOut" }}
            />
            <motion.p 
              className="text-black"
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3, duration: 0.6 }}
            >
              We provide an exceptional learning environment with comprehensive support services to help you achieve your academic and career goals.
            </motion.p>
          </motion.div>
          
          <motion.div 
            className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
            variants={container}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-50px" }}
          >
            {features.map((feature, index) => (
              <motion.div 
                key={index} 
                className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 text-center group"
                variants={item}
                whileHover={{ 
                  y: -10,
                  boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                  scale: 1.02
                }}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ 
                  delay: index * 0.1, 
                  duration: 0.6,
                  type: 'spring',
                  stiffness: 80
                }}
              >
                <motion.div 
                  className="mb-4"
                  initial={{ scale: 0.8, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ 
                    delay: index * 0.1 + 0.1,
                    type: 'spring',
                    stiffness: 100
                  }}
                >
                  {feature.icon}
                </motion.div>
                <motion.h3 
                  className="text-xl font-semibold text-gray-900 mb-3"
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 + 0.2, duration: 0.5 }}
                >
                  {feature.title}
                </motion.h3>
                <motion.p 
                  className="text-black"
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 + 0.3, duration: 0.5 }}
                >
                    {feature.description}
                  </motion.p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </motion.section>

      {/* Testimonials Section */}
      <motion.section 
        className="py-16 bg-gray-50 overflow-hidden"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container mx-auto px-4">
          <motion.div 
            className="text-center max-w-3xl mx-auto mb-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <motion.div 
              className="inline-block px-4 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-4"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              Testimonials
            </motion.div>
            <motion.h2 
              className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1, duration: 0.6 }}
            >
              What Our Community Says
            </motion.h2>
            <motion.div 
              className="w-20 h-1 bg-primary mx-auto mb-6"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.8, ease: "backOut" }}
            />
          </motion.div>
          
          <motion.div 
            className="grid md:grid-cols-3 gap-8"
            variants={container}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-50px" }}
          >
            {[
              {
                quote: "The faculty's dedication to student success is truly remarkable. The hands-on learning approach prepared me exceptionally well for my career.",
                author: "Alex Johnson",
                role: "Computer Science Graduate, Class of 2023"
              },
              {
                quote: "The diverse community and inclusive environment made my learning experience enriching. I've built connections that will last a lifetime.",
                author: "Maria Garcia",
                role: "Business Administration, Class of 2024"
              },
              {
                quote: "The research opportunities and mentorship I received were instrumental in my academic growth. Truly a transformative experience.",
                author: "James Wilson",
                role: "Research Assistant, Engineering Department"
              }
            ].map((testimonial, index) => (
              <motion.div 
                key={index} 
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 group"
                variants={item}
                whileHover={{ 
                  y: -10,
                  boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                  scale: 1.02
                }}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ 
                  delay: index * 0.15, 
                  duration: 0.6,
                  type: 'spring',
                  stiffness: 80
                }}
              >
                <motion.div 
                  className="text-yellow-400 text-2xl mb-4"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ 
                    delay: index * 0.15 + 0.1,
                    type: 'spring',
                    stiffness: 100
                  }}
                >
                  "
                </motion.div>
                <motion.p 
                  className="text-black italic mb-4"
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.15 + 0.2, duration: 0.5 }}
                >
                  {testimonial.quote}
                </motion.p>
                <motion.div 
                  className="border-t border-gray-100 pt-4"
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.15 + 0.3, duration: 0.5 }}
                >
                  <p className="font-semibold text-black">{testimonial.author}</p>
                  <p className="text-sm text-black">{testimonial.role}</p>
                </motion.div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </motion.section>

      {/* Team Section */}
      <motion.section 
        className="py-16 bg-white relative overflow-hidden"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8 }}
      >
        <motion.div 
          className="absolute inset-0 bg-grid-primary-100/20 [mask-image:linear-gradient(0deg,#fff,rgba(255,255,255,0.6))]"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        />
        <div className="relative z-10">
          <div className="container mx-auto px-4">
            <motion.div 
              className="text-center max-w-3xl mx-auto mb-16"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <motion.div 
                className="inline-block px-4 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full mb-4"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
              >
                Our Team
              </motion.div>
              <motion.h2 
                className="text-3xl md:text-4xl font-bold text-black mb-4"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1, duration: 0.6 }}
              >
                Meet Our Expert Team Members
              </motion.h2>
              <motion.div 
                className="w-20 h-1 bg-primary mx-auto mb-6"
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2, duration: 0.8, ease: "backOut" }}
              />
              <motion.p 
                className="text-black"
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3, duration: 0.6 }}
              >
                Our dedicated team of experienced educators and researchers are committed to providing quality education and mentorship.
              </motion.p>
            </motion.div>
            
            <motion.div 
              className="grid md:grid-cols-2 lg:grid-cols-5 gap-6"
              variants={container}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-50px" }}
            >
              {teamMembers.map((member, index) => (
                <motion.div 
                  key={index} 
                  className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 group"
                  variants={item}
                  whileHover={{ 
                    y: -10,
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                    scale: 1.02
                  }}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ 
                    delay: index * 0.1, 
                    duration: 0.6,
                    type: 'spring',
                    stiffness: 80
                  }}
                >
                  <motion.div 
                    className="overflow-hidden h-64 relative"
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.5 }}
                  >
                    <img 
                      src={member.image}
                      alt={`Portrait of ${member.name}, ${member.role}`}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      loading="lazy"
                      width="300"
                      height="300"
                      sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
                    />
                    <motion.div 
                      className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6"
                      initial={{ opacity: 0 }}
                      whileHover={{ opacity: 1 }}
                    >
                      <div className="flex justify-center space-x-4 w-full">
                        <motion.a 
                          href={member.social.facebook} 
                          className="text-white hover:text-primary transition-colors bg-black/30 backdrop-blur-sm p-2 rounded-full"
                          whileHover={{ y: -5, scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                        >
                          <FaFacebookF className="text-lg" />
                        </motion.a>
                        <motion.a 
                          href={member.social.twitter} 
                          className="text-white hover:text-primary transition-colors bg-black/30 backdrop-blur-sm p-2 rounded-full"
                          whileHover={{ y: -5, scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                        >
                          <FaTwitter className="text-lg" />
                        </motion.a>
                        <motion.a 
                          href={member.social.linkedin} 
                          className="text-white hover:text-primary transition-colors bg-black/30 backdrop-blur-sm p-2 rounded-full"
                          whileHover={{ y: -5, scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                        >
                          <FaLinkedinIn className="text-lg" />
                        </motion.a>
                      </div>
                    </motion.div>
                  </motion.div>
                  <div className="p-6 text-center">
                    <motion.h3 
                      className="text-xl font-semibold text-gray-900 mb-1"
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: index * 0.1 + 0.2, duration: 0.5 }}
                    >
                      {member.name}
                    </motion.h3>
                    <motion.p 
                      className="text-primary font-medium mb-4"
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: index * 0.1 + 0.3, duration: 0.5 }}
                    >
                      {member.role}
                    </motion.p>
                  </div>
                </motion.div>
              ))}
            </motion.div>
            
            <motion.div 
              className="text-center mt-12"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3, duration: 0.6 }}
            >
              {/* <motion.button 
                className="bg-primary hover:bg-primary/90 text-white font-medium py-3 px-8 rounded-md transition-colors inline-flex items-center group"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                View All Faculty Members
                <motion.span 
                  className="ml-2 inline-flex items-center"
                  animate={{ x: [0, 5, 0] }}
                  transition={{ repeat: Infinity, duration: 1.5, ease: 'easeInOut' }}
                >
                  <FaArrowRight />
                </motion.span>
              </motion.button> */}
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* Footer */}
      
    </div>
  );
};

  

export default AboutUs;
